import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { default as OnClickOut, InjectedOnClickOutProps, HandleClickOutside } from 'react-onclickoutside';

type Props = {
  close: () => void
  children: JSX.Element | string
}

type ComponentProps = Props & InjectedOnClickOutProps & HandleClickOutside<any>

class Component extends React.Component<ComponentProps> implements HandleClickOutside<any> {
  constructor(props: ComponentProps) {
    super(props);
  }

  componentDidMount() {
    if (this.shouldAddPositionFixed()) {
      document.body.classList.add('position--fixed');
    }
    document.addEventListener("keydown", this.onKeydown);
  }

  componentWillUnmount() {
    document.body.classList.remove('position--fixed');
    document.removeEventListener("keydown", this.onKeydown);
  }

  handleClickOutside(evt : any) {
    this.props.close()
  }

  shouldAddPositionFixed() : boolean {
    return /iPad|iPhone.*(OS 11_\d+)/.test(navigator.userAgent);
  }

  onKeydown = (e : KeyboardEvent) : void => {
    if (e.keyCode == 27) {
      this.props.close();
    }
  }

  render() {
    return (
      <div
        className={`popup ${this.shouldAddPositionFixed() ? 'popup--open' : ''}`}
      >
        {this.props.children}
      </div>
    )
  }
}

const OutComponent = OnClickOut<Props>(Component)

export class Popup extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    return ReactDOM.createPortal(
      <>
        <div className='popup-backdrop' id='overlay' style={{display: 'block', opacity: 1}}></div>
        <OutComponent
          close={this.props.close}
        >
          {this.props.children}
        </OutComponent>
      </>,
      document.getElementsByTagName("body")[0]
    );
  }
}
